/*******************************************************
PLAYER SEARCH EVENT HANDLERS
This handles events related to the player search boxes.
********************************************************/

import addHoverClass from '../universal/hover/add-class';
import clearSearch from './clear';
import debounce from '../universal/debounce/debounce';
import handleKeyboardNavigation from './handle-keyboard-nav';
import removeHoverClass from '../universal/hover/remove-class';
import showMobileSearchBox from './show-mobile-search-box';
//import showTopNavSearch from './show-top-nav-search';
import triggerSearchPlayers from './trigger-search';

export default function addPlayerSearchEventHandlers() {

    // Show the search box on small devices when the search icon button is tapped
    $(document).on('click', '.top-nav-section__search-icon', showMobileSearchBox);

    // Show the search input box in the top navigation when the button is clicked
    //$(document).on('click', '.t-nav__search-button', showTopNavSearch);

    // Watch for typing inside the gamer search box
    $(document).on('input', "input[name='playersearch']", debounce(triggerSearchPlayers, 300));

    // Watch for keyboard navigation events inside the gamer search box
    $(document).on('keyup', "input[name='playersearch']", handleKeyboardNavigation);

    // Clear player search box and results
    $(document).on('click', '#player-search-clear', clearSearch);

    // Control when hover effects are used on search results
    $(document).on('touchstart mouseenter', '.search-result', addHoverClass);
    $(document).on('mouseleave', '.search-result', removeHoverClass);

}
